import { categoryOfAgentSystem, categoryOfCableSystem, POWER_BOARD_CATEGORIES } from "../deviceCategories";
import type { DeviceCategory } from "../deviceCategories";
import type { CableSystem } from "../../utils/fetchCables";
import type { SuggestBoardFeed } from "./types";

const BY_NAME: Array<[RegExp, DeviceCategory]> = [
  [/\bsibe\b|sicherheitsbeleucht|\bcps\b|\bzb\b|\bsv\b|notlicht/i, "emergencyLighting"],
  [/\bbmz\b|brandmeld|\bbma\b/i, "fireAlarm"],
  [/\bemz\b|\bema\b|einbruch/i, "intruderAlarm"],
  [/\bdv\b|datenverteil|\bsat\b|\bmmz\b|netzwerk|\bisp\b/i, "data"],
  [/\bpa\b|\bpas\b|\bhes\b|erdung|potentialausgleich/i, "earthing"],
  [/\bzlt\b|\bglt\b|\bknx\b/i, "buildingServices"],
];

const CABLE_SYSTEMS: CableSystem[] = ["power", "knx", "bma", "media", "intercom", "safety", "earthing"];
const asCableSystem = (value: string): CableSystem | undefined =>
  CABLE_SYSTEMS.find((system) => system === value);

const only = (category: DeviceCategory) => ({ categories: [category], excludedTypes: [] });

export const suggestBoardFeed: SuggestBoardFeed = ({ name, label, system, agentSystems = [] }) => {
  const text = `${name} ${label}`;
  const named = BY_NAME.find(([pattern]) => pattern.test(text))?.[1];
  if (named) return { feed: only(named), reason: "name" };
  const fromAgent = agentSystems
    .map((value) => categoryOfAgentSystem(value) ?? categoryOfCableSystem(asCableSystem(value)))
    .find((category): category is DeviceCategory => Boolean(category) && category !== "other");
  if (fromAgent) return { feed: only(fromAgent), reason: "agent" };
  const fromMarker = categoryOfCableSystem(system);
  if (fromMarker) return { feed: only(fromMarker), reason: "name" };
  return { feed: { categories: [...POWER_BOARD_CATEGORIES], excludedTypes: [] }, reason: "power" };
};
